import { PolicyListItem } from '@/shared/types/policy.types'
import { GetPolicyResponse } from '@/shared/types/response.types'
import { AxiosResponse } from 'axios'
import HttpService from '../HttpService'
import { formDataGenerator } from '@/shared/api/api.utils'

const getBaseUrlForDocuments = () => {
  let baseUrl = '/'
  if (import.meta.env.MODE === 'development') {
    baseUrl = (import.meta.env.VUE_APP_PUBLIC_API_URL || '').replace('/api/v2', '/')
  }

  return baseUrl
}

export class PolicyService extends HttpService {  
  async getPolicyList(
    passportNo: string,
    birthdate: string,
    response_token: string,
    controller?: AbortController
  ): Promise<PolicyListItem[]> {
    const { data } = await this.post<AxiosResponse>(
      'getvisitorspolicy',
      formDataGenerator({
        passportNo,
        birthdate,
        response_token,
      }),
      { signal: controller?.signal }
    )
    return data.data
  }

  getPolicyDocument(passportNo: string, policyNo: string, controller?: AbortController) {
    return this.get<AxiosResponse | undefined>('policy', {
      headers: {
        'Content-Type': 'application/pdf',
      },
      params: {
        action: 'getvisitorspdf',
        passportno: passportNo,
        policyno: policyNo,
      },
      signal: controller?.signal,
      baseURL: getBaseUrlForDocuments(),
    })
  }

  getPolicyDocumentByLink(link: string) {
    return this.get<AxiosResponse | undefined>(link, {
      headers: {
        'Content-Type': 'application/pdf',
      },
      baseURL: getBaseUrlForDocuments(),
    })
  }

  getPolicy(): Promise<GetPolicyResponse> {
    return this.post('getpolicy')
  }
}
